import { Store } from '@ngrx/store';
import { Component, signal, Output, EventEmitter, input, model, WritableSignal, Input, effect, computed, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_COMBOBOX } from "@progress/kendo-angular-dropdowns";
import { ControlsModule } from '@pmis3/ui-controls';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { IconsModule } from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { IServiceApplication, IVesselActivity, IVesselStop, selectServiceApplicationTypes } from '@pmis3/vessel-activity-core';
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_LABEL } from "@progress/kendo-angular-label";
import { VesselVisitDetailMovementServiceApplicationPickerButtonComponent } from './vessel-visit-detail-movement-service-application-picker-button/vessel-visit-detail-movement-service-application-picker-button.component';

@Component({
    selector: 'pmis3-vessel-visit-detail-movement-service-application-picker',
    standalone: true,
    imports: [CommonModule, ControlsModule, KENDO_COMBOBOX, KENDO_DIALOGS, KENDO_BUTTONS, IconsModule, KENDO_INPUTS, KENDO_LABEL, VesselVisitDetailMovementServiceApplicationPickerButtonComponent],
    templateUrl: 'vessel-visit-detail-movement-service-application-picker.component.html',
    styleUrl: "vessel-visit-detail-movement-service-application-picker.component.scss"
})
export class VesselVisitDetailMovementServiceApplicationPickerComponent {
    serviceApplicationsId = input.required<number[]>();
    showDialog = signal(false);
    serviceApplicationType = this.store.selectSignal(selectServiceApplicationTypes)

    @Output() serviceApplicationsIdChange = new EventEmitter<number[]>();
    @Input() wrapperClasses = "justify-content-center";

    state = computed(() => {
        const serviceApplicationsId = this.serviceApplicationsId();
        const mappedServiceApplications = this.serviceApplicationType().map(type => {
            const match = serviceApplicationsId.some(id => id == type.id);
            const icon = this.icons.find(x => x.id == type.id)?.icon || "clip";
            return {
                label: type.name,
                icon: icon,
                applicationTypeId: type.id,
                value: signal<boolean | undefined>(match)
            }
        })
        return {
            serviceApplicationsForDisplay: signal(mappedServiceApplications)
        }
    })

    ////temparary solution for service application, Need to refactor this later
    icons: { id: ServiceApplicationTypeEnum; icon: string; }[] = [
        { id: ServiceApplicationTypeEnum.Anchorage, icon: "mdi mdi-anchor" },
        { id: ServiceApplicationTypeEnum.ScrubberDeclaration, icon: "mdi mdi-brush-variant" },
        { id: ServiceApplicationTypeEnum.HotWork, icon: "mdi mdi-fire" },
        { id: ServiceApplicationTypeEnum.Lifeboat, icon: "mdi mdi-sail-boat" },
        { id: ServiceApplicationTypeEnum.Bunkering, icon: "pi pi-bunkering" },
        { id: ServiceApplicationTypeEnum.EngineImmobilization, icon: "mdi mdi-engine-off" },
        { id: ServiceApplicationTypeEnum.Diving, icon: "mdi mdi-diving-helmet" },
    ];

    constructor(private store: Store<any>) { }

    onToggleService(typeId: number, newValue: boolean | undefined) {
        this.state().serviceApplicationsForDisplay().find(sa => sa.applicationTypeId == typeId)?.value.set(newValue);
        const selectedServiceApplicationIds = this.state().serviceApplicationsForDisplay().flatMap(sa => sa.value() ? [sa.applicationTypeId] : []);
        this.serviceApplicationsIdChange.emit(selectedServiceApplicationIds);
    }

    // serviceAppConfigs = computed(() =>
    //     this.serviceApplicationType().map(type => ({
    //         label: type.name,
    //         icon: "star" //TODO: add logic to populate icons dynamically
    //     }))
    // );

    // [
    //     { label: "Anchorage", icon: "star", field: "hasAnchorage" },
    //     { label: "Scrubber Declaration", icon: "star", field: "hasScrubberDeclaration" },
    //     { label: "Hot Work", icon: "star", field: "hasHotWork" },
    //     { label: "Lifeboat", icon: "star", field: "hasLifeboat" },
    //     { label: "Bunkering", icon: "star", field: "hasBunkering" },
    //     { label: "Engine Immobilization", icon: "star", field: "hasEngineImmobilization" },
    //     { label: "Diving", icon: "star", field: "hasDiving" }
    // ];

    // hasNoServiceApplications = computed(() => this.state().serviceApplicationsForDisplay().every(sa => !sa.value()));

    // toggleDialog() {
    //     this.showDialog.update(show => !show)
    // }

    // save() {
    //     const selectedServiceApplicationIds = this.state().serviceApplicationsForDisplay().flatMap(sa => sa.value() ? [sa.applicationTypeId] : []);

    //     // let updatedVesselActivity = this.vesselActivity()
    //     // for (let i = 0; i < this.serviceApplicationsForDisplay().length; i++) {
    //     //     const field = this.serviceAppConfigs[i].field;
    //     //     updatedVesselActivity = {
    //     //         ...updatedVesselActivity,
    //     //         [field]: this.serviceApplicationsForDisplay()[i].value()
    //     //     }
    //     // }
    //     // this.vesselActivity.set(updatedVesselActivity);
    //     // this.vesselActivityChange.emit(this.vesselActivity())

    //     this.toggleDialog();
    //     this.serviceApplicationsIdChange.emit(selectedServiceApplicationIds);

    // }
}

// type BooleanKeys<T> = Exclude<{
//     [K in keyof T]: T[K] extends boolean | undefined ? K : never
// }[keyof T], undefined>;

// type VesselActivityBooleanField = BooleanKeys<IVesselActivity>;

// interface ServiceApplicationConfig {
//     label: string;
//     icon: string;
//     // field: VesselActivityBooleanField;
// }

////temparary solution for service application, Need to refactor this later
enum ServiceApplicationTypeEnum {
    Anchorage = 280,
    ScrubberDeclaration = 281,
    HotWork = 282,
    Lifeboat = 283,
    Bunkering = 284,
    EngineImmobilization = 286,
    Diving = 285
}